module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_chapter1"
    }
  }, [_vm._v("1. Wealth of Nations: The Cultural Nexus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Developed and less developed countries differ substantially in their world views regarding free markets, governance, and the role of the individual in society, which accounts for their different economic track records")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_chapter2"
    }
  }, [_vm._v("2. The Evolution of Societies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The theory of societal evolution and its unfolding from mankind’s prehistory provides a framework for understanding the origins of cultures and their ability to change")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Commerce: Driver of Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Man’s propensity for enterprise is the lead driver of societal evolution, bringing new ways and world views in its wake")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Securing Ordered Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("New political institutions were invoked drawing on a Greco-Roman heritage but made efficacious and enduring by British political ingenuity")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Emergence of Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Science emerged uniquely in the West because only it had the essential enabling world views and metaphysics")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Empowerment of the Individual")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All these evolutionary forces called forth and were strengthened by empowered individuals who were more intellectually independent and assumed greater initiative")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Cross-Cultural Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The world’s cultures vary enormously in their readiness to adopt the prescriptions of the extended order despite the ready availability of models, foreign capital, and science itself")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Innate Resistance to Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Even countries enjoying the benefits of the extended order resist its dictates. Ongoing debates shed light on what has been achieved in value change and the hurdles ahead for others")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_works_cited",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Works Cited")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0